import { isNavGroup, type NavGroup } from "./navigation-data";

export function isCurrentPath(pathname: string, href: string) {
  return href === "/" ? pathname === href : pathname === href || pathname.startsWith(`${href}/`);
}

export function containsCurrentPath(group: NavGroup, pathname: string): boolean {
  return (
    (group.href ? isCurrentPath(pathname, group.href) : false)
    || group.children.some((item) =>
      isNavGroup(item) ? containsCurrentPath(item, pathname) : isCurrentPath(pathname, item.href),
    )
  );
}
